import React, { useState } from 'react';
import {
    required,
    Create,
    SelectInput,
    ReferenceInput,
    SimpleForm,
    FileInput,
    FileField
} from 'react-admin';

import PopupCreateToolbar from "../../../common/PopupCreateToolbar";
import * as apiClient from "../../../common/apiClient";

const ClaimDocumentsCreate = props => {

    const [loading, setLoading] = useState(false);

    const initialValues = {
        calimOrdId: props.calimOrdId
    };

    const handleSubmit = async (formdata) => {

        try {

            setLoading(true);

            if (!formdata.docUrl || formdata.docUrl.length === 0) {
                setLoading(false);
                return;
            }

            for (const doc of formdata.docUrl) {

                const uploadedUrl = await apiClient.UploadFile("docUrl", doc);

                let data = {
                    docSection: 'ClaimOrdDocs',
                    claimOrderid: parseInt(formdata.calimOrdId),
                    docPurposeId: formdata.docPurpId,
                    docTypeId: formdata.docTypeId,
                    docFilename: doc.title || doc.rawFile?.name,
                    docUrl: uploadedUrl
                };

                await apiClient.addDocument(data);
            }

            setLoading(false);

            // close popup after all uploads completed
            props.onClose();

        }
        catch (error) {

            console.log(error);
            setLoading(false);
        }
    };

    return (
        <Create {...props}>
            <SimpleForm
                onSubmit={handleSubmit}
                initialValues={initialValues}
                toolbar={
                    <PopupCreateToolbar
                        label={loading ? "Uploading..." : "Save"}
                        onSave={handleSubmit}
                        onClose={props.onClose}
                        onCancel={props.onCancel}
                        disabled={loading}
                    />
                }
                variant="outlined"
            >

                <FileInput
                    multiple={true}
                    fullWidth={true}
                    source="docUrl"
                    label="Document"
                    labelMultiple="Upload documents..."
                    disabled={loading}
                >
                    <FileField source="src" title="title" />
                </FileInput>

                <ReferenceInput
                    validate={[required("Please select ")]}
                    perPage={500}
                    sort={{ field: 'name', order: 'ASC' }}
                    label="Purpose Type"
                    source="docPurpId"
                    reference="lookups"
                    filter={{ type: 'CLPUR' }}
                    fullWidth={true}
                >
                    <SelectInput optionText="name" disabled={loading} />
                </ReferenceInput>

                <ReferenceInput
                    perPage={500}
                    sort={{ field: 'name', order: 'ASC' }}
                    label="Document Type"
                    source="docTypeId"
                    reference="lookups"
                    filter={{ type: 'DT' }}
                    fullWidth={true}
                >
                    <SelectInput optionText="name" disabled={loading} />
                </ReferenceInput>

            </SimpleForm>
        </Create>
    );
};

export default ClaimDocumentsCreate;